import { defaultHttpClient } from '../../httpClient';
import type { GetGoodsReviewsParams, GetGoodsReviewsResponse } from './types';

/**
 * - 상품 리뷰 목록 조회 API
 */
export const getGoodsReviews = (
  goodsSno: number,
  params?: GetGoodsReviewsParams,
) => {
  return defaultHttpClient
    .request<GetGoodsReviewsResponse>({
      method: 'GET',
      url: `/webview/goods/${goodsSno}/reviews/`,
      params,
    })
    .then(result => result.data);
};